import { Welcome } from './Welcome';

export const Welcomes = {
  Welcome,
};

export const welcomesList = [Welcome] as const;

export const welcomesMapping = {
  [Welcome.config.name]: Welcome,
} as const;
